<template>
	<div class="page-main">
		<nav-bar :border="false" :left-arrow="true" @click-left="pageBack"></nav-bar>

		<div class="form-box">
			<img src="~@/assets/ic_fresh_new_logo.png" class="logo" alt="" />
			<div class="title">绑定星礼卡</div>
			<div class="input-group">
				<input type="text" v-model="id" placeholder="请输入卡号" />
			</div>
			<div class="input-group">
				<input type="password" v-model="pin" placeholder="请输入密码" />
			</div>
			<button class="btn" @click="sendCard">绑定</button>
		</div>
	</div>
</template>

<script>
	import {
		navBar
	} from "vant";
	import {
		sendCard
	} from "@/api";
	export default {
		data() {
			return {
				qrcode: null,
				id: null,
				pin: null,
			};
		},
		methods: {
			sendCard() {
				if (!this.id) {
					this.$msg("请输入卡号");
					return;
				}
				if (!this.pin) {
					this.$msg("请输入密码");
					return;
				}
				sendCard(this.id, this.pin).then((d) => {
					if (d.data && d.data.error) {
						this.$msg(d.data.error.message);
					} else {
						this.$msg("绑定成功");
					}
				});
			},
			pageBack() {
				window.history.back();
			},
		},
		components: {
			navBar,
		},
	};
</script>

<style lang="scss" scoped>
	.page-main {
		background: #f1f1f1;
		

		::v-deep .van-nav-bar {
			background: transparent;

			.van-nav-bar__title,
			.van-nav-bar__left .van-icon {
				color: #333 !important;
			}
		}

		.form-box {
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
			margin: 180px 40px 0;
			padding: 160px 40px 80px;
			border-radius: 30px;
			background: #fff;
			position: relative;

			.logo {
				width: 260px;
				height: 260px;
				left: 50%;
				top: 0;
				margin-left: -130px;
				margin-top: -130px;
				border: 20px solid #fff;
				border-radius: 50%;
				position: absolute;
				box-sizing: border-box;
			}

			.title {
				margin-bottom: 60px;
				font-size: 40px;
				text-align: center;
			}

			.input-group {
				background: #f1f1f1;
				margin-bottom: 30px;
				border-radius: 16px;
				overflow: hidden;

				input {
					font-size: 32px;
					border: 0;
					height: 90px;
					padding: 0 30px;
					background: transparent;
				}
			}

			.btn {
				margin: auto;
				margin-top: 80px;
				border-radius: 44px;

				display: block;
				height: 88px;
				border: 0;
				width: 500px;
				background: #5bad70;
				color: #fff;
				font-weight: bold;
				box-sizing: border-box;
				font-size: 30px;
			}
		}
	}
</style>